import toast from 'react-hot-toast';
import api from "../Crypto/axios.js";
export const LOGIN_USER = 'LOGIN_USER';
export const SET_SHOW_LOADER = "SET_SHOW_LOADER";


const initialState = {
  LoginUser: [],
  isLoading: false,
};

const LoginReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        LoginUser: action.payload,
      };
       case SET_SHOW_LOADER:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
};

export default LoginReducer;

export const loginSuccess = (loginUser) => ({
  type: LOGIN_USER,
  payload: loginUser,
});

export const setShowLoader = (set) => ({
  type: SET_SHOW_LOADER,
  payload: set,
});


// export const LoginUser = (data) => {
//   return async (dispatch) => {
//     const user = {
//       grant_type: 'password',
//       username: data.emailId,
//       password: data.password,
//     };

//     const credentials = btoa(
//       `${process.env.REACT_APP_CLIENT_ID}:${process.env.REACT_APP_CLIENT_SECRET}`
//     );

//     const formData = new URLSearchParams();

//     for (const key in user) {
//       formData.append(key, user[key]);
//     }

//     const url = `${process.env.REACT_APP_API_URL}/nrcb/ecom/oauth/token`;

//     const promise = (async () => {
//       try {
//         const response = await fetch(url, {
//           method: 'POST',
//           body: formData.toString(),
//           headers: {
//             'Content-Type': 'application/x-www-form-urlencoded',
//             Authorization: `Basic ${credentials}`,
//           },
//         });

//         if (!response.ok) {
//           const errorData = await response.json();
//           const errorMessage = errorData.error_description || 'Login failed';
//           console.error('Login failed:', errorData);
//           throw new Error(errorMessage); // Throw an error to be caught later
//         }

//         const responseData = await response.json();
//         return responseData;
//       } catch (error) {
//           if (error instanceof TypeError) {
//             console.error('Network error during login:', error);
//             throw new Error('Network error. Please check your connection.');
//           } else {
//             console.error('Error during login:', error);
//             throw error;
//           }
//       }
//     })();

//     toast.promise(promise, {
//       loading: 'Logging in...',
//       success: 'Login successful!',
//       error:  'Login failed. Please try again.'
//     });

//     return promise;
//   };
// };

export const LoginUser = (data) => {
  return async (dispatch) => {
    const user = {
      grant_type: 'password',
      username: data.emailId,
      password: data.password,
    };

    const promise = (async () => {
      try {
        const response = await api.post('/nrcb/ecom/oauth/token', user, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Basic ${btoa(
              `${process.env.REACT_APP_CLIENT_ID}:${process.env.REACT_APP_CLIENT_SECRET}`
            )}`,
          },
        });

        if (!response) {
          const errorData = response;
          console.error('Login failed:', errorData);
          const errorMessage = errorData.error_description || 'Login failed';
          throw new Error(errorMessage);
        }

        return response;
      } catch (error) {
        console.error('Error during login:', error);
        throw error;
      }
    })();

    toast.promise(promise, {
      loading: 'Logging in...',
      success: 'Login successful!',
      error: 'Login failed. Please try again.',
    });

    return promise;
  };
};

export const forgetPassword = (data) => {
  return async (dispatch) => {
    const promise = (async () => {
      try {
        const response = await api.post('/nrcb/ecom/forget/password', data, {
          requiresAuth: true,
        });
        return response;
      } catch (error) {
        let errorMessage = 'Forget password failed';
        if (error.response?.status === 404) {
          errorMessage = 'No account found with this email';
        } else if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        }
        console.error('Error in forget password:', errorMessage);
        throw new Error(errorMessage);
      }
    })();

    toast.promise(promise, {
      loading: 'Processing...',
      success: 'Password reset link sent!',
      error: (error) => error.message || 'Forget password failed',
    });

    return promise;
  };
};

// export const RefreshToken = (refreshToken) => {
//   return async (dispatch) => {
//     const formData = new URLSearchParams();
//     formData.append('grant_type', 'refresh_token');
//     formData.append('client_id', process.env.REACT_APP_CLIENT_ID);
//     formData.append('client_secret', process.env.REACT_APP_CLIENT_SECRET);
//     formData.append('refresh_token', refreshToken);

//     const promise = (async () => {
//       try {
//         const response = await api.post('/nrcb/ecom/oauth/refreshtoken', formData.toString(), {
//           headers: {
//             'Content-Type': 'application/x-www-form-urlencoded',
//           },
//         });
//         return response;
//       } catch (error) {
//         let errorMessage = 'Failed to refresh token';
//         if (error.response?.status === 404) {
//           errorMessage = 'Refresh token not found';
//         } else if (error.response?.data?.message) {
//           errorMessage = error.response.data.message;
//         }
//         console.error('Error refreshing token:', errorMessage);
//         throw new Error(errorMessage);
//       }
//     })();

//     toast.promise(promise, {
//       loading: 'Refreshing session...',
//       success: 'Session refreshed successfully',
//       error: (error) => error.message || 'Failed to refresh token',
//     });

//     return promise;
//   };
// };

// export const forgetPassword = (data) => {
//   return async (dispatch) => {
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/nrcb/ecom/forget/password`,
//         {
//           method: 'POST',
//           body: JSON.stringify(data),
//           headers: { 'Content-Type': 'application/json' },
//         }
//       );
//       if (!response.ok) {
//         const errorData = await response.json();
//         const errorMessage = errorData.message || 'Forget password failed';
//         if (response.status === 404) {
//           toast.error('No account found with this email');
//         } else {
//           toast.error(errorMessage);
//         }
//         throw new Error(errorMessage);
//       }
//       const val = await response.json();
//       return val;
//     } catch (error) {
//       console.error('Error in forget password:', error);
//       throw error;
//     }
//   };
// };

export const refreshAccessToken = (refreshToken) => {
  return async (dispatch) => {
    const formData = new URLSearchParams();
    formData.append('grant_type', 'refresh_token');
    formData.append('client_id', process.env.REACT_APP_CLIENT_ID);
    formData.append('client_secret', process.env.REACT_APP_CLIENT_SECRET);
    formData.append('refresh_token', refreshToken);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/nrcb/ecom/oauth/refreshtoken`,
        {
          method: 'POST',
          body: formData.toString(),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );
      const responseData = await response.json();
      if (!response.ok) {
        const errorMessage =
          responseData.error_description || 'Failed to refresh token';
        toast.error(errorMessage);
        throw new Error(errorMessage);
      }
      // toast.success('Token refreshed successfully');
      return responseData;
    } catch (error) {
      console.error('Error refreshing token:', error);
      throw error;
    }
  };
};

